
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartUserProposal as ObiChartUserProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-user-proposal.js';
 
 
 

 
 export const ObiChartUserProposal = createComponent({
   react: React,
   tagName: 'obi-chart-user-proposal',
   elementClass: ObiChartUserProposalElement,
   events: {
     
   }
  });
 
 